module.exports = __webpack_public_path__ + "static/media/logo-gets.8fa13d4f.svg";